<template>
  <div class="vacancy-company">
    <div class="vacancy-company__title">
      <BasicAvatar
        :href="company.href"
        :image="{ 
          src: company.logo,
          alt: `Логотип компании «${company.name}»`
        }"
        size="extra-small"
        roundness="small"
      />
      <BasicLink
        :href="company.href"
        :title="company.name"
        appearance="dark"
      />
    </div>
     <div class="vacancy-company__sub-title">
      {{company.description}}
     </div>

     <div class="vacancy-company__footer">
      <BasicLink
        v-if="company.url && company.url.href && company.url.text"
        :href="company.url.href"
        :title="company.url.text"
        target="_blank"
        rel="noreferrer nofollow"
      />
      <BasicLink
        v-if="company.vacancies"
        :href="`${company.href}/vacancies`"
        :title="linkTitle"
        appearance="dimmed"
      />
     </div>
  </div>
</template>

<script>
import BasicAvatar from 'src/components/BasicAvatar/BasicAvatar.vue';
import BasicLink from 'src/components/BasicLink/BasicLink.vue';

export default {
  name: 'VacancyCompany',
  components: { BasicAvatar, BasicLink },
  props: {
    company: {
      type: Object,
      required: false,
    },
    showInactive: {
      type: Boolean,
    }
  },
  computed: {
    linkTitle() {
      if (this.showInactive) {
        return  `Все вакансии (${this.company.vacancies.active}/${this.company.vacancies.inactive})`;
      }
      return  `Все вакансии (${this.company.vacancies.active})`;
    }
  }
};
</script>